import { smoothScroll, clickOutside, sticktothetop } from "./helper-functions";

const $doc = $(document);
const $win = $(window);

/* Document events */

$doc
  .on(
    "click",
    ".template-cart .cart-wrapper .cart-wrapper__actions .btn",
    function(e) {
      e.preventDefault();
      $('.form.form--cart .form__actions .btn[type="submit"]').trigger("click");
    }
  )
  .on("click", ".menu__item--closed > a", function(e) {
    e.preventDefault();

    $(this)
      .parent()
      .removeClass("menu__item--closed")
      .siblings(".menu__item--has-dropdown")
      .addClass("menu__item--closed");
  })
  .on("click", ".dropdown--filter .btn--clear", function(e) {
    e.preventDefault();

    $(".bc-sf-filter-clear-all").trigger("click");
  })
  .on("click", ".btn--clear", function(e) {
    e.preventDefault();
    const href = document.location.href;
    const search = document.location.search;
    let newUrl = "";

    if (search.indexOf("&") > 0) {
      const index = search.indexOf("&") + 1;
      const newSearch = search.substring(0, index);
      newUrl = href.replace(newSearch, "?");
      location.replace(newUrl);
    } else {
      newUrl = href.replace(search, "");
      location.replace(newUrl);
    }
  })
  .on("mouseup", function(e) {
    e.preventDefault();

    clickOutside(
      $(
        ".dropdown.expanded .dropdown__controls, .nav-expanded .nav, .search-expanded .header__search"
      ),
      e
    );
  })
  .on("click", ".nav-trigger, .dropdown-trigger, .search-trigger", function(e) {
    e.preventDefault();
    const toggleClass = $(this).data("toggle-class");

    $(".wrapper").toggleClass(toggleClass);

    if ($(this).hasClass("search-trigger")) {
      $(".search__field").focus();
    }
  })
  .on("click", ".dropdown-trigger", function(e) {
    e.preventDefault();
    const toggleClass = $(this).data("toggle-class");

    $(this)
      .closest(".dropdown")
      .toggleClass(toggleClass)
      .siblings()
      .removeClass(toggleClass);
  })
  .on("click", ".btn--clear", function(e) {
    e.preventDefault();
    $(this).hide();
  })
  .on(
    "click",
    ".dropdown:not(.disabled) li a .bc-sf-filter-option-value, .dropdown:not(.disabled) .bc-sf-filter-filter-dropdown a, .dropdown-trigger",
    function(e) {
      e.preventDefault();
      const $this = $(this);

      $(".jspScrollable").each(function() {
        $this.removeClass("jspScrollable");
      });

      $(".dropdown").each(function() {
        $this.addClass("disabled");
      });

      setTimeout(function() {
        $(".dropdown--filter .btn--clear").toggle(
          document.location.search.includes("=pf&")
        );
        $(".dropdown--sort .btn--clear").toggle(
          document.location.search.includes("?sort=")
        );

        $(".dropdown").each(function() {
          $this.removeClass("disabled");
        });
      }, 500);
    }
  )
  .on("change", '.product__add input[type="radio"]', function(e) {
    e.preventDefault();

    const newValue = $(this).val();
    const $select = $(this)
      .closest("form")
      .find('select[name="id"]');
    $select.val(newValue);
  })
  .on("click", ".scroll-top", function(e) {
    e.preventDefault();
    smoothScroll(this);
  });

/* Window events */

$win.on("load resize", function(e) {
  $(".header .stick-here").height($(".header__body").outerHeight());

  if (e.type === "load") {
    Shopify.colorLabels();
    const urlAttributes = window.location.search;
    this.window.cartPopupDelay =
      parseInt($(".cart-trigger-js").data("close_delay")) * 1000;

    if (urlAttributes && urlAttributes.indexOf("sort") !== -1) {
      $(".dropdown--sort .btn--clear").show();
    }
  }
});

$(function() {
  $win.scroll(sticktothetop);
  sticktothetop();
});

setTimeout(function() {
  $win.trigger("resize");
}, 100);
